import React, { useContext } from 'react'
import Caption from 'components/Luxkit/Typography/Caption'
import GeoContext from 'contexts/geoContext'
import AutoTooltip from 'components/Common/AutoTooltip'
import AutoTooltipContent from 'components/Common/AutoTooltip/AutoTooltipContent'
import { getSearchDistanceLabel } from './searchDistanceLabel'
import { useTranslation } from 'react-i18next'

interface Props {
  searchTargetLabel: string;
  distance: number;
}

function SearchTargetDistance(props: Props) {
  const { currentRegionCode } = useContext(GeoContext)
  const { t } = useTranslation('search')
  const label = getSearchDistanceLabel(t, props.searchTargetLabel, props.distance, currentRegionCode)

  return <AutoTooltip>
    <Caption variant="medium" colour="neutral-three">
      {label}
    </Caption>
    <AutoTooltipContent width={230}>
      {t('distanceDisclaimer', { ns: 'search' })}
    </AutoTooltipContent>
  </AutoTooltip>
}

export default SearchTargetDistance
